<!--抄表结算方案-->
<template>
  <div>
     <Alert type="warning" style="width: 612px;padding-right: 16px;font-size:12px">
      区间收费、阶梯收费、常规高级、区间高级、阶梯高级即将上线
    </Alert>
    <Tabs :value="data.type" v-if="loaded" @on-click="test">
      <TabPane label="常规收费" name="1" disabled><type1 ref="type1" :data="data"/></TabPane>
      <TabPane label="区间收费" name="2" disabled><type2 ref="type2" :data="data"/></TabPane>
      <TabPane label="阶梯收费" name="3" disabled><type3 ref="type3" :data="data"/></TabPane>
      <TabPane label="常规高级" name="4" disabled><type4 ref="type4" :data="data"/></TabPane>
      <TabPane label="区间高级" name="5" disabled><type5 ref="type5" :data="data"/></TabPane>
      <TabPane label="阶梯高级" name="6" disabled><type6 ref="type6" :data="data"/></TabPane>
    </Tabs>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import type1 from "./types/type1";
import type2 from "./types/type2";
import type3 from "./types/type3";
import type4 from "./types/type4";
import type5 from "./types/type5";
import type6 from "./types/type6";
export default {
  components: { type1, type2, type3, type4, type5, type6 },
  data() {
    return {
      data: {
        type: "1",
        basics: 0,
        name: ""
      },
      loaded: false
    };
  },
  methods: {
    test(){
      this.$Message.error('即将上线');
    },
    sendData() {
      console.log(52);
      return this.data;
    },
    ...mapActions(["GetMeterChargeDetail"])
  },
  mounted() {
    if (this.$route.params.id) {
      this.GetMeterChargeDetail({ id: this.$route.params.id }).then(res => {
        this.loaded = true;
        res.type = `${res.type}`;
        this.data = res;
      });
    } else {
      this.loaded = true;
    }
  },
  computed: mapGetters({
    user: "agent"
  })
};
</script>

<style lang="less">
@import "./index.less";
</style>
